/**
 * Admin Portal Design Tokens (Mantis Free)
 *
 * Extracted from Mantis Free React Admin Template source:
 * - NavItem: borderRight active indicator, primary.lighter bg
 * - MainCard: grey.A800 border, elevation 0
 * - AnalyticEcommerce: p 2.25, h4 count, chip percentage
 * - NavGroup: subtitle2 group labels, pl 3
 * - AppBar: zIndex drawer+1, search bar on left
 */

export const adminTokens = {
  // Surface hierarchy (Mantis defaults)
  bgPage: '#fafafb',
  bgSurface: '#FFFFFF',
  bgSidebar: '#FFFFFF',
  bgAppBar: '#FFFFFF',

  // Borders (Mantis uses grey.A800 = #e6ebf1)
  borderCard: '#e6ebf1',
  borderLight: '#e6ebf1',
  borderDivider: '#f0f0f0',

  // Shadows (Mantis uses elevation 0 by default, subtle on hover)
  shadowCard: 'none',
  shadowHover: '0 2px 14px 0 rgba(32,40,45,0.08)',

  // Spacing
  sidebarWidth: 260,
  appBarHeight: 64,
  contentPadding: { xs: 2, sm: 3 },
  cardPadding: 2.25,

  // Radius (Mantis uses theme default ~8px)
  radiusCard: '8px',
  radiusSmall: '4px',

  // Typography weights
  fontWeightTitle: 600,
  fontWeightSubtitle: 500,

  // Nav item styling (Mantis pattern: borderRight indicator, not bg fill)
  nav: {
    activeBg: 'primary.lighter',
    activeColor: 'primary.main',
    activeBorder: '2px solid',
    activeBorderColor: 'primary.main',
    inactiveColor: 'text.secondary',
    hoverBg: 'action.hover',
    groupLabelColor: 'text.secondary',
    itemPaddingY: 0.75,
    itemPaddingX: 1.5,
    iconSize: '1rem',
    levelIndent: 28,
  },

  // Stat card (AnalyticEcommerce pattern)
  stat: {
    padding: 2.25,
    countVariant: 'h4' as const,
    titleColor: 'text.secondary',
  },
} as const;
